// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carrossel-wrapper {
  position: relative;
  width: 93%;
  display: grid;
  align-items: center;
  justify-content: center;
  margin-left: 0.625rem;
  grid-template-columns: 10px 1fr 10px; 
}

/* Container principal do carrossel */
.carrossel-container {
  grid-column: 2;
  position: relative;
  width: 94%;
  max-width: 98%;
  margin: 0 auto;
  margin-left: 2.1rem;
  overflow: hidden;
  align-items: flex;
  gap: 1.063rem;
  box-sizing: border-box;
  
}

/* Área onde os cards deslizam */
.carrossel {
  display: flex;
  gap: 1rem;
  transition: transform 0.4s ease-in-out;
}

/* Card de livro */
.card-livro {
  background: var(--cor-roxoClaro);
  border-radius: 1rem;
  width: 11.875rem;
  height: 16.25rem;
  padding: 1rem;
  text-align: center;
  flex-shrink: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

/* Ícone de favorito */
.favorito {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}

.btn-visualizar:hover {
  text-decoration: underline;
}

/* Sem livros favoritados */

.sem-favoritos {
  width: 11.875rem;
  height: 290px;
  /* position: relative; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  left: 85%;
  text-align: center;
  color: var(--cor-preto);
  font-size: 1.2rem;
  opacity: 0.8;
}

.imagem-sem-favoritos {
  width: 150px;
  margin-bottom: 16px;
  opacity: 0.7;
}

/* Setas de navegação */
.seta {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
  background-color: var(--cor-roxoEscuro);
  border: none;
  border-radius: 8px;
  font-size: 28px;
  color: var(--cor-branco);
  cursor: pointer;
  height: 55%;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.seta-esquerda {
  left: -15px;
}

.seta-direita {
  right: -30px;
}

.seta:disabled {
  opacity: 0.3;
  cursor: default;
}

/* Responsivo */
@media (max-width: 768px) {
  .card-livro {
    width: 160px;
    height: 230px;
  }

  .imagem-livro {
    width: 90px;
    height: 60px;
  }

  .seta {
    font-size: 22px;
    width: 30px;
  }

  .seta-esquerda {
    left: -35px;
  }

  .seta-direita {
    right: -35px;
  }
}

/* CSS do Kauan */

.cards-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1.5rem;
  width: 100%;
  height: 100%;
}

.faixa {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 20rem;
  height: 2.5rem;
  margin: 24px 0 16px 0px;
}

.faixa-img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.faixa-texto {
  position: relative;
  z-index: 2;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 1rem;
  color: var(--cor-branco);
  margin-left: 1rem;
}

.card {
  background: var(--cor-roxoClaro);
  border-radius: 1rem;
  max-width: 18.75rem;
  max-height: 15.75rem;
  padding: 1rem;
  text-align: center;
  flex-shrink: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 0.25rem;
}

.card-img {
  width: 7.5rem;
  height: 4.688rem;
  object-fit: contain;
  margin-bottom: 0.625rem;
}

.card-title {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--cor-preto);
  margin: 4px 0 2px 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.autor {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 0.75rem;
  color: var(--cor-pretoApoio);
  margin: 0 0 8px 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.genero,
.ano-publicacao {
  background: #e6daf9;
  border-radius: 0.279rem;
  font-family: "Inter", sans-serif;
  font-size: 0.75rem;
  color: var(--cor-pretoApoio);
  padding: 4px 10px;
  margin: 2px 0;
  display: inline-block;
}

.card-link-telaperfil {
  font-family: "Inter", sans-serif;
  font-size: 0.75rem;
  color: var(--cor-roxoEscuro);
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  margin-top: auto;
  background-color: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 14.8rem;
  transition: color 0.2s ease, -webkit-text-decoration 0.2s ease;
  transition: color 0.2s ease, text-decoration 0.2s ease;
  transition: color 0.2s ease, text-decoration 0.2s ease, -webkit-text-decoration 0.2s ease;
}

.card-link:hover {
  color: var(--cor-roxoApoio);
  text-decoration: underline;
}

.card-link img {
  width: 0.875rem;
  height: 0.875rem;
}

.mensagem-sem-top5 {
  text-align: center;
  font-size: 1rem;
  color: var(--cor-preto);
  margin-top: 0.875rem;
  font-style: italic;
}

@media (max-width: 1280px) {
  .carrossel-wrapper{
    margin-left: 2.5rem;
  }
  .carrossel-container {
    max-width: calc(2 * 235px + 0rem);
  }
  .seta-direita {
    right: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Componets/LivrosFavoritos.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,qCAAqC;AACrC;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;;AAExB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,SAAS;EACT,sCAAsC;AACxC;;AAEA,kBAAkB;AAClB;EACE,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,2BAA2B;;AAE3B;EACE,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,iBAAiB;;AAEjB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,8DAAsD;EAAtD,sDAAsD;EAAtD,yFAAsD;AACxD;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,iCAAiC;EACnC;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".carrossel-wrapper {\n  position: relative;\n  width: 93%;\n  display: grid;\n  align-items: center;\n  justify-content: center;\n  margin-left: 0.625rem;\n  grid-template-columns: 10px 1fr 10px; \n}\n\n/* Container principal do carrossel */\n.carrossel-container {\n  grid-column: 2;\n  position: relative;\n  width: 94%;\n  max-width: 98%;\n  margin: 0 auto;\n  margin-left: 2.1rem;\n  overflow: hidden;\n  align-items: flex;\n  gap: 1.063rem;\n  box-sizing: border-box;\n  \n}\n\n/* Área onde os cards deslizam */\n.carrossel {\n  display: flex;\n  gap: 1rem;\n  transition: transform 0.4s ease-in-out;\n}\n\n/* Card de livro */\n.card-livro {\n  background: var(--cor-roxoClaro);\n  border-radius: 1rem;\n  width: 11.875rem;\n  height: 16.25rem;\n  padding: 1rem;\n  text-align: center;\n  flex-shrink: 0;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n/* Ícone de favorito */\n.favorito {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n}\n\n.btn-visualizar:hover {\n  text-decoration: underline;\n}\n\n/* Sem livros favoritados */\n\n.sem-favoritos {\n  width: 11.875rem;\n  height: 290px;\n  /* position: relative; */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  left: 85%;\n  text-align: center;\n  color: var(--cor-preto);\n  font-size: 1.2rem;\n  opacity: 0.8;\n}\n\n.imagem-sem-favoritos {\n  width: 150px;\n  margin-bottom: 16px;\n  opacity: 0.7;\n}\n\n/* Setas de navegação */\n.seta {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 3;\n  background-color: var(--cor-roxoEscuro);\n  border: none;\n  border-radius: 8px;\n  font-size: 28px;\n  color: var(--cor-branco);\n  cursor: pointer;\n  height: 55%;\n  width: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: opacity 0.3s ease;\n}\n\n.seta-esquerda {\n  left: -15px;\n}\n\n.seta-direita {\n  right: -30px;\n}\n\n.seta:disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n/* Responsivo */\n@media (max-width: 768px) {\n  .card-livro {\n    width: 160px;\n    height: 230px;\n  }\n\n  .imagem-livro {\n    width: 90px;\n    height: 60px;\n  }\n\n  .seta {\n    font-size: 22px;\n    width: 30px;\n  }\n\n  .seta-esquerda {\n    left: -35px;\n  }\n\n  .seta-direita {\n    right: -35px;\n  }\n}\n\n/* CSS do Kauan */\n\n.cards-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1.5rem;\n  width: 100%;\n  height: 100%;\n}\n\n.faixa {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 20rem;\n  height: 2.5rem;\n  margin: 24px 0 16px 0px;\n}\n\n.faixa-img {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 1;\n}\n\n.faixa-texto {\n  position: relative;\n  z-index: 2;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n  font-size: 1rem;\n  color: var(--cor-branco);\n  margin-left: 1rem;\n}\n\n.card {\n  background: var(--cor-roxoClaro);\n  border-radius: 1rem;\n  max-width: 18.75rem;\n  max-height: 15.75rem;\n  padding: 1rem;\n  text-align: center;\n  flex-shrink: 0;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.25rem;\n}\n\n.card-img {\n  width: 7.5rem;\n  height: 4.688rem;\n  object-fit: contain;\n  margin-bottom: 0.625rem;\n}\n\n.card-title {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: var(--cor-preto);\n  margin: 4px 0 2px 0;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.autor {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  font-size: 0.75rem;\n  color: var(--cor-pretoApoio);\n  margin: 0 0 8px 0;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.genero,\n.ano-publicacao {\n  background: #e6daf9;\n  border-radius: 0.279rem;\n  font-family: \"Inter\", sans-serif;\n  font-size: 0.75rem;\n  color: var(--cor-pretoApoio);\n  padding: 4px 10px;\n  margin: 2px 0;\n  display: inline-block;\n}\n\n.card-link-telaperfil {\n  font-family: \"Inter\", sans-serif;\n  font-size: 0.75rem;\n  color: var(--cor-roxoEscuro);\n  text-decoration: none;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.25rem;\n  margin-top: auto;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  position: absolute;\n  top: 14.8rem;\n  transition: color 0.2s ease, text-decoration 0.2s ease;\n}\n\n.card-link:hover {\n  color: var(--cor-roxoApoio);\n  text-decoration: underline;\n}\n\n.card-link img {\n  width: 0.875rem;\n  height: 0.875rem;\n}\n\n.mensagem-sem-top5 {\n  text-align: center;\n  font-size: 1rem;\n  color: var(--cor-preto);\n  margin-top: 0.875rem;\n  font-style: italic;\n}\n\n@media (max-width: 1280px) {\n  .carrossel-wrapper{\n    margin-left: 2.5rem;\n  }\n  .carrossel-container {\n    max-width: calc(2 * 235px + 0rem);\n  }\n  .seta-direita {\n    right: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
